import React from 'react';
import { PermissionAwareButtonDropdown } from 'src/components/PermissionAwareButtonDropdown';
import { ButtonDropdownProps } from '@cloudscape-design/components';
import { PermissionLevel } from 'src/components/PermissionAwareButtonDropdown';

export interface OperatorAction {
  name: string;
  actionFn: () => void;
  disabled?: boolean;
  disabledReason?: string;
  description: string;
  requiredPermission: PermissionLevel;
}

interface OperatorActionsMenuProps {
  loading?: boolean;
  actions: OperatorAction[];
}

export const OperatorActionMenu = ({
  loading,
  actions,
}: OperatorActionsMenuProps) => {
  if (actions.length === 0) return <></>;

  const itemClickHandler = (
    event: CustomEvent<ButtonDropdownProps.ItemClickDetails>,
  ) => {
    const clickedAction = actions.find(
      (action) => action.name === event.detail.id,
    );
    clickedAction?.actionFn();
  };

  const items = actions.map((action) => {
    return {
      text: action.name,
      id: action.name,
      disabled: action.disabled,
      disabledReason: action.disabledReason,
      requiredPermission: action.requiredPermission,
      actionDescription: action.description,
    };
  });

  return (
    <PermissionAwareButtonDropdown
      loading={loading}
      onItemClick={itemClickHandler}
      className="inline-size-override"
      items={items}
    >
      Actions
    </PermissionAwareButtonDropdown>
  );
};
